import React from 'react';
import { parseToBoolean, isLiteView, isBloomBerg, isStaticMode } from '../../utils/general/general';
import { checkDomEntitlement } from '../../utils/general/checkDomEntitlement';
import { RSCH_HTML_TRACKING_CONFIG } from '../../readership/trackingConfig';
import { enterKeyPressed } from '../../utils/general/enterKey';

interface IAuthorEmailProps {
    isNewOutput: boolean;
    email: string;
    analystId: string;
    serial: number;
    displayEmail?: string;
    emailAnalystFlag?: string;
    product?: string;
    issuer?: string;
    researchArea?: string;
    productBranding?: string;
    titleText?: string;
}
class AuthorEmail extends React.PureComponent<IAuthorEmailProps, any> {
    private ANALYST_EMAIL = React.createRef<HTMLDivElement>();
    constructor(props: IAuthorEmailProps) {
        super(props);
    }

    public componentDidMount() {
        this.ANALYST_EMAIL.current && checkDomEntitlement(this.ANALYST_EMAIL.current);
    }

    public getMailTo(e: { currentTarget: { href: string } }) {
        let _sub = "";
        if (!window.HTML_RENDITION.initialData.isDeaden('ANALYST_EMAIL') && !window.HTML_RENDITION.initialData.isEntitled('ANALYST_EMAIL')) {
            return;
        }
        if (isBloomBerg()) {
            return;
        }
        if (this.props.product?.toLowerCase() === "company") {
            _sub = this.props.issuer || '';
        } else if ((this.props.product?.toLowerCase() === "industry" || this.props.product?.toLowerCase() === "round_up")) {
            _sub = this.props.researchArea || '';
        } else if (this.props.product?.toLowerCase() === "globaliser") {
            _sub = this.props.productBranding || '';
        }
        if (_sub) _sub += " - ";
        // track author email click
        RSCH_HTML_TRACKING_CONFIG.trackAuthorEmailClick(this.props.email, this.props.analystId);
        e.currentTarget.href = 'mailto:' + this.props.email + "?subject=" + encodeURIComponent(_sub + (this.props.titleText || ''));
    }

    public showAuthorEmail = () => {
        if (this.props.isNewOutput) {
            return parseToBoolean(this.props.displayEmail || '');
        }
        return parseToBoolean(this.props.emailAnalystFlag || '');
    };

    public authorEmailDom() {
        if (isLiteView()) {
            return null;
        }
        if (isStaticMode()) {
            return (
                <div
                    ref={this.ANALYST_EMAIL}
                    data-entitlement="ANALYST_EMAIL"
                    id={'authorEmail' + this.props.serial}
                    className="authorEmail"
                    data-name={this.props.analystId}
                >
                    <a role="link" aria-label={this.props.email}>{this.props.email}</a>
                </div>
            );
        }
        return (
            <div
                ref={this.ANALYST_EMAIL}
                data-entitlement="ANALYST_EMAIL"
                id={'authorEmail' + this.props.serial}
                className="authorEmail text-overflow"
                title={this.props.email}
                data-name={this.props.analystId}
            >
                <a tabIndex={0} aria-label={this.props.email} role="link"
                    onKeyPress={(e) => enterKeyPressed(e, this.getMailTo.bind(this, e))}
                    onClick={(e) => this.getMailTo(e)} target="_top" >{this.props.email}</a>
            </div>
        );
    }

    public render() {
        if (!this.showAuthorEmail()) {
            return null;
        }
        return this.authorEmailDom();
    }
}
export default AuthorEmail;
